import { render, staticRenderFns } from "./ProfileTA.vue?vue&type=template&id=61de0b69&"
import script from "./ProfileTA.vue?vue&type=script&lang=js&"
export * from "./ProfileTA.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports